import {
    IconButton,
    Link
} from '@mui/material';

import { FAQUrl } from '../../../../../src/appsettings';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from 'react';

function Question() {
    return (
        <>
        <Link target="_blank" href={FAQUrl} rel="noopener">
        <IconButton ><HelpOutlineIcon /> </IconButton>
        </Link>
            
        </>
    );
}

export default Question;